module.exports = __webpack_public_path__ + "img/scale.74972fc2.svg";